import { render } from "./CreateToken.vue?vue&type=template&id=5c73211c&scoped=true"
import script from "./CreateToken.vue?vue&type=script&lang=js"
export * from "./CreateToken.vue?vue&type=script&lang=js"

import "./CreateToken.vue?vue&type=style&index=0&id=5c73211c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c73211c"]])

export default __exports__